import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import ReactImageFallback from "react-image-fallback";

const styles = theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)(props => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});


const DialogContent = withStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

export default class ExercisePreviewButton extends Component {
	state = {
		open: false
	};

	render() {
		const { community, isMobile } = this.props;
		const { open } = this.state;
		return (
			<div>

				<Dialog onClose={() => this.setState({ open: false })} aria-labelledby="customized-dialog-title" open={open}>
					<DialogTitle id="customized-dialog-title" onClose={() => this.setState({ open: false })}>
						Detail
        			</DialogTitle>
					<DialogContent dividers>
						<Typography gutterBottom>
							<div className="modalBody modal-content" style={{ width: isMobile ? '100%' : 320 }}>
								<div style={{
									display: 'flex',
									flexDirection: 'column'
								}}>
                                { (community.url  && !community.isImage) && 
									<div style={{
										display: 'flex',
										justifyContent: 'center',
										width: '100%'
									}}>
										<video  src={community.url} autoPlay style={{ width: '100%', height: 200, objectFit: 'fill' }} loop />
									</div>
                                }
                                { (community.url && community.isImage) && 
											<ReactImageFallback 
											 src={community.url} 
											 fallbackImage={'/assets/img/no-image-icon.png'}
											 className="responsive" />
										
                                }
									<div style={{
										backgroundColor: COLORS.greyFour,
										padding: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}>
										<div style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center'
										}}>
											
											<div style={{
												fontWeight: 'bold',
												textAlign: 'center',
												wordBreak: 'break-word'
											}}>
												{community.title}
											</div>
											{community.description &&
												<div style={{
													fontWeight: 'bold',
													marginTop: 10
												}}>
													Description
												</div>
											}
											<div style={{ textAlign: 'left', wordBreak: 'break-word' }}>
												{community.description}
											</div>
										</div>
									</div>
								</div>
							</div>
						</Typography>
					</DialogContent>
				</Dialog>
				<span
					className="link"
					onClick={() => this.setState({ open: true })}
					style={{ float: 'right', marginLeft: isMobile && 10 }}>
					<FontAwesomeIcon size={isMobile && "2x" } icon="eye" title={'Detail'}
						style={{ marginRight: 5, color: COLORS.orange }} />
				</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/PreviewCommunityButton.js